module.exports = __webpack_public_path__ + "static/img/logo.0d79052.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/home/logo.png
// module id = BFdm
// module chunks = 2